import Lenis from '@studio-freight/lenis'

class LenisInit {
    // 1. describe and create/initiate our object
    constructor() {
        const anchorLinks = document.querySelectorAll('a[href^="#"]');
        "use strict";
        const lenis = new Lenis({
            lerp: 0.085,
            wheelMultiplier: 1.8,
            infinite: false,
            gestureOrientation: "vertical",
            normalizeWheel: false,
            smoothTouch: false,
            orientation: "vertical",
            smoothWheel: true,
        });

        function raf(time) {
            lenis.raf(time)
            requestAnimationFrame(raf)
        }

        function easeOutQuint(x) {
            return 1 - Math.pow(1 - x, 5);
        }

        anchorLinks.forEach(element => {
            if (element.hasAttribute('data-lenis-anchor')) {
                element.addEventListener('click', () => {
                    lenis.scrollTo(element,{
                        offset: 1400,
                        immediate: false,
                        duration: 1.6,
                    });
                })
            }

        });

        requestAnimationFrame(raf)
    }
}

export default LenisInit;
